export default "__VITE_ASSET__6474c0d1__"